import { IconButtonShape } from './icon-button.constants';

/*
  Keep every utility a complete literal string — Tailwind scans this file as
  text, so template-literal concatenation would not be detected.
*/

// IconButton corner shape. A full-round square renders as a circle.
export const shapeClass: Record<IconButtonShape, string> = {
  [IconButtonShape.ROUNDED]: 'rounded',
  [IconButtonShape.CIRCLE]: 'rounded-full',
};
